<template>
  <el-dialog
    v-model="visible"
    width="400px"
    transition="dialog-bounce"
    :show-close="false"
    align-center
    lock-scroll
    :close-on-click-modal="false"
  >
    <template #header="{ close }">
      <div class="dialog-header">
        <el-icon :size="20" @click="close" class="close-btn">
          <Close />
        </el-icon>
        <h2>{{ dialogData.payType === 'wepay' ? '微信支付' : '支付宝支付' }}</h2>
      </div>
    </template>
    <div class="dialog-content">
      <div class="price">¥ {{ dialogData.price.toFixed(2) }}</div>
      <div ref="qrCodeRef" class="qr-code">
        <el-image
          :src="dialogData.qrCodeUrl"
          :preview-src-list="[dialogData.qrCodeUrl]"
          fit="cover"
        />
      </div>
      <div class="desc">{{ dialogData.validityTime }}S后过期</div>
      <div class="footer" @click="close">完成支付</div>
    </div>
  </el-dialog>
</template>

<script setup>
  import { ref, unref, defineExpose, defineEmits, useTemplateRef, nextTick } from 'vue'

  const emits = defineEmits(['timeout'])

  const visible = ref(false)

  const initData = {
    payType: 'wepay',
    price: 0,
    qrCodeUrl: '',
    validityTime: 0
  }
  const dialogData = ref({
    ...initData
  })

  const qrCodeRef = useTemplateRef('qrCodeRef')
  const show = async options => {
    Reflect.ownKeys(unref(dialogData)).forEach(k => {
      dialogData.value[k] = options[k] ?? initData[k]
    })
    visible.value = true

    if (options.payType === 'wepay') {
      // TODO
      console.log('支付宝支付')
      startTimeout()
    } else if (options.payType === 'alipay') {
      await nextTick()
      if (unref(qrCodeRef) && options.qrCodeUrl) {
        qrCodeRef.value.innerHTML = options.qrCodeUrl
        nextTick(() => {
          const payForm = document.forms[document.forms.length - 1]
          // payForm.setAttribute('target', '_blank')
          payForm.submit()
          payForm.remove()
          visible.value = false
        })
      }
    }
  }

  let startTimer = null
  const startTimeout = () => {
    startTimer && clearInterval(startTimer)
    startTimer = setInterval(() => {
      dialogData.value.validityTime = unref(dialogData).validityTime - 1
      if (unref(dialogData).validityTime <= 0) {
        startTimer && clearInterval(startTimer)
        visible.value = false
        emits('timeout')
      }
    }, 1000)
  }

  const close = () => {
    visible.value = false
  }

  defineExpose({ show })
</script>

<style scoped lang="scss">
  .dialog-header {
    position: relative;

    h2 {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
    }

    .close-btn {
      position: absolute;
      right: 0;
      cursor: pointer;
    }
  }

  .dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 20px 60px;

    .price {
      font-size: 22px;
      color: #f00;
      font-weight: 700;
    }

    .qr-code {
      width: 100px;
      height: 100px;
    }

    .desc {
      font-weight: 700;
      color: #47a07f;
    }

    .footer {
      width: 100%;
      padding: 8px 0;
      border-radius: 100vh;
      background-color: #026ccb;
      text-align: center;
      color: #fff;
      cursor: pointer;
    }
  }
</style>
